/* istanbul ignore file */

export const getWindowObj = (): Window => {
    return window;
};
